export default "__VITE_ASSET__83a4e12e__"